import React, { useState, useRef, useEffect } from 'react'
import './CustomTooltip.css' // Assuming you have a CSS file for basic styling

const CustomTooltip = ({ children, content, ...props }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [isTouchDevice, setIsTouchDevice] = useState(false)
  const timeoutRef = useRef(null)
  const tooltipRef = useRef(null)

  const showTooltip = () => {
    clearTimeout(timeoutRef.current)
    setIsVisible(true)
  }

  const hideTooltip = () => {
    timeoutRef.current = setTimeout(() => {
      setIsVisible(false)
    }, 1500) // Adjust delay as needed
  }

  const toggleTooltipOnTouch = () => {
    if (isTouchDevice) {
      setIsVisible(prevIsVisible => !prevIsVisible)
    }
  }

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current) // Cleanup timeout on component unmount
  }, [])

  // Detect if the device is a touch device
  useEffect(() => {
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0)
  }, [])

  return (
    <div
      className="tooltip-container"
      onMouseLeave={hideTooltip}
      onTouchEnd={toggleTooltipOnTouch}
      style={props.style || {}}
    >
      <div onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
        {children}
      </div>
      {isVisible && (
        <div
          className="tooltip-content"
          ref={tooltipRef}
          onMouseEnter={() => clearTimeout(timeoutRef.current)}
          onMouseLeave={hideTooltip}
        >
          {content}
          {/* <button className="close-button" onClick={() => setIsVisible(false)}>
            Close
          </button> */}
        </div>
      )}
    </div>
  )
}

export default CustomTooltip